module.exports = __webpack_public_path__ + "static/media/pencil2-green.e89abf10.svg";